import { render } from "./FivthBar.vue?vue&type=template&id=50a5fe6e&scoped=true"
import script from "./FivthBar.vue?vue&type=script&lang=js"
export * from "./FivthBar.vue?vue&type=script&lang=js"

import "./FivthBar.vue?vue&type=style&index=0&id=50a5fe6e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a5fe6e"]])

export default __exports__